import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRefreshQuery } from "../../features/api/authApiSlice";
import { setCredentials, setAuthChecked } from "./authSlice";

export default function PersistLogin() {
  const dispatch = useDispatch();

  const { accessToken, authChecked, loggedOut } = useSelector(
    (state) => state.auth
  );

  const { data, isLoading, isError } = useRefreshQuery(undefined, {
    skip: Boolean(accessToken) || loggedOut || authChecked,
  });

  useEffect(() => {
    if (loggedOut) return;

    if (data?.accessToken) {
      dispatch(setCredentials(data));
      return;
    }

    if (isError) {
      dispatch(setAuthChecked());
    }
  }, [data, isError, loggedOut, dispatch]);

  if (!accessToken && !authChecked && !loggedOut && isLoading) {
    return <p>Loading...</p>;
  }

  return <Outlet />;
}
